import { render } from "./registration-account-create.vue?vue&type=template&id=1a76b724&scoped=true"
import script from "./registration-account-create.vue?vue&type=script&lang=js"
export * from "./registration-account-create.vue?vue&type=script&lang=js"

import "./registration-account-create.vue?vue&type=style&index=0&id=1a76b724&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a76b724"]])

export default __exports__